// extracted by mini-css-extract-plugin
export default {"project_card":"ProjectCard_project_card__Qcjw+","tech_button":"ProjectCard_tech_button__6qt25"};